module.exports = __webpack_public_path__ + "img/MirrorCut3.ee33a289.png";